import Sidebar from '../components/sidebar/Sidebar';
import NavbarAdmin from '../components/navbar/NavbarAdmin';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getAllProducts, updateProduct, removeProductPromo } from '../services/productService';
import Modal from '../components/ui/Modal';
import dayjs from 'dayjs';
import swal from 'sweetalert';

const PromoProductsScreen = () => {
  const { slug } = useParams();
  const [promoProducts, setPromoProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [promoData, setPromoData] = useState({ promoPercentage: '', promoStartDate: '', promoEndDate: '', newPrice: '' });
  const [currentStep, setCurrentStep] = useState(1);
  const [isEditing, setIsEditing] = useState(false);
  const [productSearchTerm, setProductSearchTerm] = useState('');

  const today = dayjs().startOf('day');
  const productsPerPage = 12;

  useEffect(() => { fetchPromoProducts(); }, []);
useEffect(() => {
  const term = searchTerm.toLowerCase();

  const filtered = promoProducts.filter(prod => {
    const name = prod.name?.toLowerCase() || '';
    const description = prod.description?.toLowerCase() || '';
    const promoPercent = prod.promoPercentage?.toString() || '';
    const initial = prod.initialPrice || 0;
    const newPrice = (initial * (1 - prod.promoPercentage / 100)).toFixed(2);

    return (
      name.includes(term) ||
      description.includes(term) ||
      promoPercent.includes(term) ||
      newPrice.includes(term)
    );
  });

  setFilteredProducts(filtered);
  setCurrentPage(1);
}, [searchTerm, promoProducts]);


  const fetchPromoProducts = async () => {
    const { data } = await getAllProducts();
    const promoList = data.filter(p => p.promoPercentage && p.promoStartDate);
    setPromoProducts(promoList);
    setFilteredProducts(promoList);
  };

  const handleAddPromoClick = async () => {
    const { data } = await getAllProducts();
    setAllProducts(data.filter(p => !p.promoPercentage));
    setSelectedProduct(null);
    setPromoData({ promoPercentage: '', promoStartDate: '', promoEndDate: '', newPrice: '' });
    setCurrentStep(1);
    setIsEditing(false);
    setShowModal(true);
  };

  const handleProductSelect = (product) => {
    setSelectedProduct(product);
    setCurrentStep(2);
  };

  const handlePromoChange = (e) => {
    const { name, value } = e.target;
    const originalPrice = selectedProduct?.initialPrice || 0;
    let updated = { ...promoData, [name]: value };
    if (name === 'promoPercentage') {
      const percentage = parseFloat(value);
      if (!isNaN(percentage) && originalPrice > 0) {
        updated.newPrice = (originalPrice * (1 - percentage / 100)).toFixed(2);
      }
    }
    if (name === 'newPrice') {
      const price = parseFloat(value);
      if (!isNaN(price) && originalPrice > 0) {
        updated.promoPercentage = ((1 - price / originalPrice) * 100).toFixed(0);
      }
    }
    setPromoData(updated);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedProduct(null);
    setPromoData({ promoPercentage: '', promoStartDate: '', promoEndDate: '', newPrice: '' });
    setCurrentStep(1);
    setIsEditing(false);
  };

  const handlePromoSubmit = async () => {
    if (!selectedProduct) return;
    const { promoPercentage, promoStartDate, promoEndDate } = promoData;
    const start = dayjs(promoStartDate), end = dayjs(promoEndDate);
    const percentage = parseInt(promoPercentage);
    if (percentage === 0) return handleDeletePromo(selectedProduct._id);
    if (!start.isValid() || !end.isValid() || start.isBefore(today) || !end.isAfter(start)) return swal("❌ Dates invalides", "Début >= aujourd’hui et Fin > Début", "error");
    if (isNaN(percentage) || percentage < 1 || percentage > 99) return swal("❌ Pourcentage invalide", "Entre 1% et 99% requis", "warning");

    setCurrentStep(3);
    const payload = {
      promoPercentage,
      promoStartDate,
      promoEndDate,
      ...(selectedProduct.subcategory
        ? { subcategory: selectedProduct.subcategory._id || selectedProduct.subcategory }
        : { category: selectedProduct.category._id || selectedProduct.category })
    };
    try {
      await updateProduct(selectedProduct._id, payload);
      setTimeout(() => {
        swal("✅ Promotion enregistrée", "", "success");
        handleModalClose();
        fetchPromoProducts();
      }, 1000);
    } catch {
      setCurrentStep(2);
      swal("❌ Erreur", "Échec de l’enregistrement", "error");
    }
  };

  const handleDeletePromo = async (id) => {
    swal({
      title: "🗑 Supprimer la promotion ?",
      text: "Cette action est irréversible",
      icon: "warning",
      buttons: ["Annuler", "Oui, supprimer"]
    }).then(async (ok) => {
      if (!ok) return;
      try {
        await removeProductPromo(id);
        swal("✅ Promotion supprimée", "", "success");
        fetchPromoProducts();
        handleModalClose();
      } catch {
        swal("❌ Échec", "La suppression a échoué", "error");
      }
    });
  };

  const paginated = filteredProducts.slice((currentPage - 1) * productsPerPage, currentPage * productsPerPage);
  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);

  return (
    <div className="flex min-h-screen">
      <div className="md:hidden fixed top-0 left-0 right-0 z-50"><NavbarAdmin slug={slug} /></div>
      <div className="hidden md:block"><Sidebar slug={slug} /></div>
      <main className="flex-1 md:ml-64 p-4 mt-16 md:mt-0">
        <div className="flex flex-col md:flex-row justify-between gap-4 items-start md:items-center mb-6">
          <h1 className="text-2xl font-bold text-paragaia">Produits en Promotion</h1>
          <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto">
            <input type="text" placeholder="Rechercher..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="w-full md:w-64 border px-3 py-2 rounded shadow-sm" />
            <button onClick={handleAddPromoClick} className="bg-paragaia text-white px-4 py-2 rounded-md hover:bg-paragaiaLight">Ajouter une Promotion</button>
          </div>
        </div>

        {filteredProducts.length > 0 ? (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {paginated.map(prod => {
                const newPrice = (prod.initialPrice * (1 - prod.promoPercentage / 100)).toFixed(2);
                return (
                    <div key={prod._id} className="bg-white rounded-xl shadow-md p-4 hover:shadow-lg transition relative">
                    {prod.promoPercentage && (
                        <span className="absolute top-2 left-2 bg-red-500 text-white text-xs font-semibold px-2 py-1 rounded-full shadow-md z-10">
                        -{prod.promoPercentage}%
                        </span>
                    )}
                    <div className="w-full h-48 rounded overflow-hidden mb-3 bg-gray-100">
                        <img src={prod.image} alt={prod.name} className="w-full h-full object-cover" />
                    </div>
                    <h2 className="text-lg font-bold truncate">{prod.name}</h2>
                    <p className="text-gray-500 line-through">{prod.initialPrice} TND</p>
                    <p className="text-paragaia text-xl font-semibold">{newPrice} TND</p>
                    <p className="text-sm text-gray-400 mt-1">{dayjs(prod.promoStartDate).format('DD/MM/YYYY')} - {dayjs(prod.promoEndDate).format('DD/MM/YYYY')}</p>
                    <div className="flex justify-between mt-4 text-sm">
                        <button onClick={() => {
                        setSelectedProduct(prod);
                        setPromoData({
                            promoPercentage: prod.promoPercentage,
                            promoStartDate: dayjs(prod.promoStartDate).format('YYYY-MM-DD'),
                            promoEndDate: dayjs(prod.promoEndDate).format('YYYY-MM-DD'),
                            newPrice
                        });
                        setIsEditing(true);
                        setCurrentStep(2);
                        setShowModal(true);
                        }} className="text-blue-600 hover:underline">🛠 Modifier</button>
                        <button onClick={() => handleDeletePromo(prod._id)} className="text-red-600 hover:underline">🗑 Supprimer</button>
                    </div>
                    </div>
                );
                })}

            </div>
            {totalPages > 1 && (
              <div className="flex justify-center mt-6 space-x-1 items-center">
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                  className={`px-3 py-1 rounded border ${
                    currentPage === 1 ? 'opacity-50 cursor-not-allowed' : 'bg-white hover:bg-gray-200'
                  }`}
                >
                  &lt;
                </button>

                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter((page) => {
                    if (page === 1 || page === totalPages) return true;
                    if (page >= currentPage - 2 && page <= currentPage + 2) return true;
                    return false;
                  })
                  .map((page, i, arr) => {
                    const prev = arr[i - 1];
                    const isGap = prev && page - prev > 1;
                    return (
                      <span key={page} className="flex items-center">
                        {isGap && <span className="px-2 text-gray-500">...</span>}
                        <button
                          onClick={() => setCurrentPage(page)}
                          className={`px-3 py-1 rounded border ${
                            currentPage === page
                              ? 'bg-paragaia text-white'
                              : 'bg-white text-paragaia hover:bg-paragaiaLight'
                          }`}
                        >
                          {page}
                        </button>
                      </span>
                    );
                  })}

                <button
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                  className={`px-3 py-1 rounded border ${
                    currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : 'bg-white hover:bg-gray-200'
                  }`}
                >
                  &gt;
                </button>
              </div>
            )}

          </>
        ) : (
          <p className="text-center text-gray-500 py-8">Aucun produit en promotion.</p>
        )}
      </main>

      <Modal show={showModal} onClose={handleModalClose}>
        <div className="space-y-6">
          <div className="flex items-center justify-center space-x-6">
            {[1, 2, 3].map(step => (
              <div key={step} className={`flex flex-col items-center ${currentStep === step ? 'text-paragaia' : 'text-gray-400'}`}>
                <div className={`w-8 h-8 flex items-center justify-center rounded-full font-bold ${currentStep === step ? 'bg-paragaia text-white' : 'bg-gray-300'}`}>{step}</div>
                <span className="mt-1 text-sm font-semibold">
                  {step === 1 ? 'Produit' : step === 2 ? 'Détails' : 'Chargement'}
                </span>
              </div>
            ))}
          </div>

          {currentStep === 1 && (
            <div>
              <h2 className="text-lg font-bold mb-2">Sélectionner un Produit</h2>
                  <input
                    type="text"
                    placeholder="Rechercher un produit..."
                    value={productSearchTerm}
                    onChange={(e) => setProductSearchTerm(e.target.value)}
                    className="w-full mb-3 border px-3 py-2 rounded shadow-sm"
                  />

              <div className="max-h-64 overflow-y-auto space-y-3">
              {allProducts
                .filter(prod => prod.name.toLowerCase().includes(productSearchTerm.toLowerCase()))
                .map(prod => (
                  <div key={prod._id} onClick={() => handleProductSelect(prod)} className="flex items-center space-x-4 p-3 border rounded cursor-pointer hover:bg-paragaiaLight transition">
                    <img src={prod.image} alt={prod.name} className="w-14 h-14 object-cover rounded" />
                    <div>
                      <span className="font-medium text-paragaia">{prod.name}</span><br />
                      <span className="text-sm text-gray-500">{prod.initialPrice} TND</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {currentStep === 2 && (
            <div className="space-y-5">
              <h2 className="text-lg font-bold">Promotion: {selectedProduct?.name}</h2>
              {[
                ['promoPercentage', 'Pourcentage (%)', 'Ex: 20'],
                ['newPrice', 'Nouveau Prix (TND)', 'Ex: 59.99'],
                ['promoStartDate', 'Date de Début'],
                ['promoEndDate', 'Date de Fin']
              ].map(([name, label, placeholder]) => (
                <div key={name}>
                  <label htmlFor={name} className="block text-sm font-medium text-gray-700">{label}</label>
                  <input
                    type={name.includes('Date') ? 'date' : 'number'}
                    name={name}
                    value={promoData[name]}
                    onChange={handlePromoChange}
                    placeholder={placeholder || ''}
                    className="mt-1 block w-full border px-3 py-2 rounded shadow-sm focus:outline-none focus:ring focus:border-paragaia"
                  />
                </div>
              ))}
              <div className="flex justify-between">
                {!isEditing && <button onClick={() => setCurrentStep(1)} className="text-paragaia hover:underline">← Retour</button>}
                <button onClick={handlePromoSubmit} className="bg-paragaia text-white px-4 py-2 rounded-md hover:bg-paragaiaLight">Enregistrer</button>
              </div>
            </div>
          )}

          {currentStep === 3 && (
            <div className="flex justify-center py-10">
              <img src="/assets/loading.gif" alt="Chargement..." className="w-25 h-25" />
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default PromoProductsScreen;
